// Indique e ganhe (canvas B07): o link pessoal, o convite pelo WhatsApp e quem já entrou.
import { useState } from 'react';
import { BONUS_POR_INDICACAO, DIAS_PARA_ACEITAR_INDICACAO } from '@truco6/planos';
import { imagemDaCarta } from '@truco6/ui';
import { conta, type Sessao } from '../comum/conta.ts';
import { medir } from '../comum/medicao.ts';
import { voltar } from '../comum/rotas.ts';
import { Rosto } from '../comum/Rosto.tsx';
import { useEu } from './planos-comum.tsx';
import { Carregando, Tela, Topo } from './comum.tsx';

export function Indique({ sessao }: { sessao: Sessao }) {
  const { eu, erro, carregar } = useEu(sessao);
  const [copiado, setCopiado] = useState<string | null>(null);

  const heroi = (
    <section className="heroi-indique" aria-label="Indique e ganhe">
      <div className="cartas-heroi" aria-hidden="true">
        {[-12, 0, 12].map((r) => <img key={r} src={imagemDaCarta('verso')} alt="" style={{ transform: `rotate(${r}deg)` }} />)}
      </div>
      <h2>Traga a turma, ganhe partidas</h2>
      <p><span className="chip-ouro">+{BONUS_POR_INDICACAO} partidas</span> por amigo que criar conta</p>
    </section>
  );

  if (!eu?.indicacao) {
    return erro ? (
      <Tela>
        <Topo titulo="Indique e ganhe" voltar={voltar} />
        <p className="erro" role="alert">{erro}</p>
        <button className="btn2 largo" onClick={() => void carregar()}>Tentar de novo</button>
      </Tela>
    ) : <Carregando />;
  }

  const { link, entraram, bonusGanho } = eu.indicacao;
  const texto = `Bora jogar truco de 6 comigo? Cria sua conta pelo meu link: ${link}`;
  async function copiar() {
    try { await navigator.clipboard.writeText(link); setCopiado('Link copiado!'); }
    catch { setCopiado('Copie o link: ' + link); }
    medir('share', { method: 'link', content_type: 'indicacao' });
    void conta.registrarConvite(sessao, { canal: 'link', tipo: 'indicacao' }).catch(() => {});
    setTimeout(() => setCopiado(null), 2500);
  }

  return (
    <Tela>
      <Topo titulo="Indique e ganhe" voltar={voltar} />
      <div className="duas-colunas">
        <div className="col">
          {heroi}
          <section aria-labelledby="h-link">
            <h2 id="h-link" className="rotulo">Seu link</h2>
            <div className="campo-link">
              <span>{link.replace(/^https?:\/\//, '')}</span>
              <button className="btn2 dourado" onClick={copiar}>Copiar</button>
            </div>
            {copiado && <p className="ok" role="status">{copiado}</p>}
          </section>
          <a className="btn1 largo botao-link" href={'https://wa.me/?text=' + encodeURIComponent(texto)} target="_blank" rel="noreferrer"
            onClick={() => { medir('share', { method: 'whatsapp', content_type: 'indicacao' }); void conta.registrarConvite(sessao, { canal: 'whatsapp', tipo: 'indicacao' }).catch(() => {}); }}>
            CONVIDAR PELO WHATSAPP
          </a>
        </div>
        <div className="col">
          <section aria-labelledby="h-convites">
            <div className="rotulo-linha">
              <h2 id="h-convites" className="rotulo">Seus convites</h2>
              <span>{entraram.length} {entraram.length === 1 ? 'entrou' : 'entraram'}</span>
            </div>
            <div className="cartao convites">
              <p className="ganhos"><b>{bonusGanho}</b><span>partidas bônus ganhas</span></p>
              {entraram.length > 0 ? (
                <ul className="quem-entrou">
                  {entraram.map((p, i) => (
                    <li key={i}><Rosto perfil={p} cor="var(--gold-400)" tamanho={56} /><span>{p.apelido}</span></li>
                  ))}
                </ul>
              ) : <p className="nota">Ninguém entrou pelo seu link ainda. Mande no grupo da turma.</p>}
            </div>
          </section>
          <p className="nota">
            Bônus entra assim que o amigo cria a conta com Google pelo seu link. Vale para conta nova, criada nos últimos {DIAS_PARA_ACEITAR_INDICACAO} dias,
            e cada amigo conta uma vez. As partidas bônus não vencem.
          </p>
        </div>
      </div>
    </Tela>
  );
}
